var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h3>Контейнер № {{ title }}</h3><table v-if=\"data.table\" class=\"custom_table\"><thead><tr><th>Тип</th><th>Дата</th><th>Операция</th><th>Транспорт</th><th>Контрагент</th></tr></thead><tfoot><tr><th v-show=\"!data.table.length\" colspan=\"5\">Нет операций по этому контейнеру</th></tr></tfoot><tbody><tr v-repeat=\"data.table\"><td title=\"{{* type.desc + ' / ' + size.desc + ' / ' + load.desc }}\"><span data-size=\"{{* size.id }}\" class=\"icon-container {{* type.id + ' ' + load.id }}\"></span></td><td>{{* date | parseTime 'full' ' '}}</td><td title=\"{{* oper + ' '+ dosmotr}}\" class=\"text-center\"><span class=\"operation {{* operations[oper][dosmotr] }}\"></span></td><td>{{* transport }}</td><td>{{* kontr }}</td></tr></tbody></table><component is=\"alert\" name=\"cnt-info\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/cnt-info/component.jade
 ** module id = 81
 ** module chunks = 0
 **/